export function clampNumber(value: number, min?: number, max?: number): number {
	let result = value
	if (min !== undefined && result < min) { result = min }
	if (max !== undefined && result > max) { result = max }
	return result
}

function decimalPlacesOf(step: number): number {
	// Outside 1e-6..1e21 JS stringifies exponentially, and the coefficient carries
	// digits of its own: 1.23e-7 needs 9 places, not the 7 the exponent implies.
	const [coefficient, exponentText] = step.toString().split('e')
	const coefficientDecimals = (coefficient.split('.')[1] ?? '').length
	return Math.max(0, coefficientDecimals - (exponentText ? Number(exponentText) : 0))
}

const MAX_TO_FIXED_DIGITS = 100

export function roundToStep(value: number, step: number): number {
	if (!Number.isFinite(step) || step <= 0) { return value }
	const result = Math.round(value / step) * step
	const decimals = decimalPlacesOf(step)
	if (decimals === 0) { return Math.round(result) }
	// toFixed throws above 100 digits, and at that scale the artifact it would
	// remove is smaller than the step itself.
	if (decimals > MAX_TO_FIXED_DIGITS) { return result }
	// Fix floating-point artifacts (e.g. 0.1 * 14 = 1.4000000000000001)
	return parseFloat(result.toFixed(decimals))
}
